import {
  ActionIcon,
  Badge,
  Box,
  Button,
  ComboboxItem,
  Flex,
  Grid,
  rem,
  Select,
  TextInput,
  Title,
  Tooltip,
} from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  IconBinaryTree,
  IconBrandBootstrap,
  IconCalendarDown,
  IconCalendarUp,
  IconFileExport,
  IconFileSearch,
  IconNumbers,
  IconPrinter,
  IconRefresh,
  IconSearch,
  IconTimeDuration15,
  IconTruckDelivery,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useLocation, useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import { repositoryPos } from "../../../_base/_const/_constVar";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { getValueById, isJSON } from "../../../_base/helper/FunctionHelper";
import { paginationBase } from "../../../_base/model/_base/BaseTable";
import {
  formatDateNotTimeZone,
  formatDateTransfer,
} from "../../../common/FormatDate/FormatDate";
import { green, olive_green, sky_blue } from "../../../const/variables";
import { MessageResponse } from "../../../model/MessageResponse";
import { getMasterOrgSelect } from "../../../service/getSelectApi";
import ConfirmInfoGHTK from "./ConfirmInfoGHTK";
import {
  getShippingVendorText,
  getTextStatus,
  warehouseStatus,
} from "./helper";
import { printGhtkLabel } from "./printGhtkLabel";
import TransferShippingFromCOD from "./TransferShippingFromCOD";
import { useTableFillScreen } from "./useTableFillScreen";

// Định nghĩa kiểu dữ liệu đơn hàng đối tác
interface AhamoveOrder {
  orderCode: string; // Mã đơn hàng nội bộ
  partnerOrderCode: string; // Mã đơn bên đối tác
}

// Định nghĩa đúng kiểu dữ liệu
type ColumnPinningType = {
  left?: string[];
  right?: string[];
};

const COD = ({ toolbar }: { toolbar: HTMLElement | null }) => {
  const navigate = useNavigate();
  const [data, setData] = useState<AhamoveOrder[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [pagination, setPagination] = useState(paginationBase);
  const [rowCount, setRowCount] = useState(0);
  const location = useLocation();
  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";
  const [visible, { toggle, open, close }] = useDisclosure(false);

  const [dataBranchSelect, setDataBranchSelect] = useState<ComboboxItem[]>([]);
  const [dataEmployeeSelect, setDataEmployeeSelect] = useState<ComboboxItem[]>(
    [],
  );
  //dataExportExcel
  const [dataExportExcel, setDataExportExcel] = useState<any[]>([]);

  // Thêm state cho filter IsReturn để sử dụng trong table config
  const [isReturnFilter, setIsReturnFilter] = useState<string>("false");
  // State để theo dõi trạng thái IsReturn đã được apply sau khi tìm kiếm
  const [appliedIsReturn, setAppliedIsReturn] = useState<string>("false");

  const dataTransferShipping = [
    { label: "GHTK", value: "GHTK" },
    { label: "Nhất Tín", value: "NHAT_TIN" },
    { label: "Tín Thành", value: "TIN_THANH" },
    { label: "Nasco", value: "NASCO" },
    { label: "Viettel", value: "VIETTEL" },
    { label: "Khác", value: "KHAC" },
  ];

  const orderStatuses = [
    { value: "DON_HANG_TAM", label: "Đơn hàng tạm" },
    { value: "DON_HANG_CHOT", label: "Đơn hàng chốt" },
    { value: "DON_HANG_CHO_DUYET_GIAM", label: "Đơn chờ duyệt giảm" },
    { value: "DON_HANG_DA_DUYET_GIAM", label: "Đơn đã duyệt giảm" },
    { value: "DON_CHO_DUYET_DOI_TRA", label: "Đơn chờ duyệt đổi trả" },
    { value: "DON_DA_DUYET_DOI_TRA", label: "Đơn đã duyệt đổi trả" },
    { value: "DON_HANG_HUY", label: "Đơn hàng hủy" },
    { value: "DON_HANG_HOAN_THANH", label: "Đơn hàng hoàn thành" },
    { value: "DON_HANG_DONG", label: "Đơn hàng đóng" },
  ];

  const sizeGrid = { base: 6, sm: 4, md: 3, lg: 3, xl: 2 };
  const searchForm = useForm({
    initialValues: {
      KeySearch: "",
      OrderNumber: "",
      Phone: "",
      FinishDate: null as Date | null,
      StartDate: new Date(
        new Date(new Date().setMonth(new Date().getMonth() - 1)).getTime() +
          7 * 60 * 60 * 1000,
      )?.toISOString(),
      EndDate: new Date(
        new Date().getTime() + 7 * 60 * 60 * 1000,
      )?.toISOString(),
      InvOrgId: "",
      InvId: "",
      CodeSal: "",
      Attribute78: "",
      IsReturn: "false", // Mặc định là "Không"
    },
  });

  // Thêm state cho filter ngày xuất kho và trạng thái đơn hàng
  const [filterOwDate, setFilterOwDate] = useState<Date | null>(
    _searchJson && checkedPinSearch ? _searchJson?.filterOwDate : null,
  );
  const [filterOrderStatus, setFilterOrderStatus] = useState<string>(
    _searchJson && checkedPinSearch ? _searchJson?.filterOrderStatus : "",
  );

  // Danh sách trạng thái đơn hàng mẫu
  const orderStatusOptions = [
    { value: "", label: "Tất cả" },
    { value: "DON_HANG_TAM", label: "Đơn hàng tạm" },
    { value: "DON_HANG_CHOT", label: "Đơn hàng chốt" },
    { value: "DON_HANG_HOAN_THANH", label: "Đơn hàng hoàn thành" },
    { value: "DON_HANG_DONG", label: "Đơn hàng đóng" },
    // ...bổ sung thêm nếu cần
  ];

  const orderStatusCOD = [
    { label: "Chưa đóng gói", value: "CHUA_DONG_GOI" },
    { label: "Đã đóng gói", value: "DA_DONG_GOI" },
  ];

  const isReturnOptions = [
    { label: "Không", value: "false" },
    { label: "Đã nhập lại", value: "true" },
  ];

  const getColorTransfer = (value: string) => {
    switch (value) {
      case "GHTK":
        return "#00EE36";
      case "NHAT_TIN":
        return "#FFD800";
      case "TIN_THANH":
        return "linear-gradient(90deg, #AA1015 0%, #8E9093 100%)";
      case "NASCO":
        return "linear-gradient(90deg, #FB3D49 0%, #D12D79 100%)";
      case "VIETTEL":
        return "#E30B29";
      case null:
      case "":
      case undefined:
        return "rgba(0, 0, 0, 0)";
      default:
        return "blue";
    }
  };

  const handleCheckView = React.useCallback(
    async (row: any) => {
      const url = `/api/v1/CreateSellItem/details?orderNumber=${row.original.orderNumber}`;
      const response = await repositoryPos.get<MessageResponse<any>>(url);
      if (response && response.success) {
        // Kiểm tra nếu orderNumber chứa "DT"
        if (row.original.orderNumber.includes("DT")) {
          navigate("/sell/view-order-return", {
            state: {
              id: row.original.id,
              orderNumber: row.original.orderNumber,
              orderType: row.original.orderType,
              actionType: "view",
              // isReadOnly:
              //   location?.pathname === "/sell/sales-order-list-read-only"
              //     ? true
              //     : false,
            },
          });
        } else {
          navigate("/sell/view-order", {
            state: {
              id: row.original.id,
              orderNumber: row.original.orderNumber,
              orderType: row.original.orderType,
              actionType: "view",
              // isReadOnly:
              //   location?.pathname === "/sell/sales-order-list-read-only"
              //     ? true
              //     : false,
            },
          });
        }
      }
    },
    [navigate],
  );

  const modalsConfirmInfo = (orderNumber: string) => {
    modals.openConfirmModal({
      title: <Title order={5}>Xác nhận thông tin !</Title>,
      size: "auto",
      children: (
        <ConfirmInfoGHTK
          orderNumber={orderNumber}
          onSuccess={fetchData}
          isCOD={true}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const modalsTransferShippingFromCOD = (orderNumber: string) => {
    modals.openConfirmModal({
      title: <Title order={5}>Điều chuyển giao vận</Title>,
      size: "auto",
      children: (
        <TransferShippingFromCOD
          onSuccess={fetchData}
          orderNumber={orderNumber}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  // Hàm gọi API lấy danh sách đơn hàng đối tác
  const fetchData = async (exportExcel?: boolean) => {
    setIsLoading(true);
    try {
      const {
        KeySearch,
        OrderNumber,
        Phone,
        FinishDate,
        StartDate,
        EndDate,
        InvOrgId,
        InvId,
        CodeSal,
        Attribute78,
        IsReturn,
      } = searchForm.values;

      // Cập nhật trạng thái applied sau khi search
      setAppliedIsReturn(IsReturn);

      let url = `/api/v1/CreateSellItem/get-list-return-sale?Skip=${
        pagination.pageIndex * pagination.pageSize
      }&Take=${pagination.pageSize}&ShipingVendor=COD`;
      const params: string[] = [];
      if (KeySearch) params.push(`KeySearch=${encodeURIComponent(KeySearch)}`);
      if (OrderNumber)
        params.push(`OrderNumber=${encodeURIComponent(OrderNumber)}`);
      if (Phone) params.push(`Phone=${encodeURIComponent(Phone)}`);
      if (FinishDate)
        params.push(`FinishDate=${FinishDate.toISOString().slice(0, 10)}`);
      if (StartDate) params.push(`StartDate=${StartDate}`);
      if (EndDate) params.push(`EndDate=${EndDate}`);
      const resolvedInvId = InvId || InvOrgId;
      if (resolvedInvId && resolvedInvId.length > 0)
        params.push(`InvId=${resolvedInvId}`);
      if (InvOrgId && InvOrgId.length > 0) params.push(`InvOrgId=${InvOrgId}`);
      if (CodeSal && CodeSal.length > 0)
        params.push(`CodeSal=${encodeURIComponent(CodeSal)}`);
      if (Attribute78 && Attribute78.length > 0)
        params.push(`Attribute78=${Attribute78}`);
      if (IsReturn) params.push(`IsReturn=${IsReturn}`);
      // Sửa lỗi lệch ngày khi tìm kiếm ngày xuất kho
      if (filterOwDate) {
        const localDate = `${filterOwDate.getFullYear()}-${(
          filterOwDate.getMonth() + 1
        )
          .toString()
          .padStart(2, "0")}-${filterOwDate
          .getDate()
          .toString()
          .padStart(2, "0")}`;
        params.push(`OwDate=${localDate}`);
      }
      if (filterOrderStatus) params.push(`OrderStatus=${filterOrderStatus}`);
      if (params.length > 0) {
        url += "&" + params.join("&");
      }
      const response = await repositoryPos.get<MessageResponse<any>>(url);
      if (response && response.success) {
        setData(response.data?.pagedList?.lists || []);
        setRowCount(response?.totalCount || 0);

        if (exportExcel && !response?.totalCount) {
          NotificationExtension.Fails(
            "Export Excel thất bại, vui lòng liên hệ phòng CNTT !",
          );
        } else if (exportExcel && response?.totalCount > 0) {
          handleExport(response?.totalCount);
        }
      } else {
        setData([]);
        setRowCount(0);
      }
    } catch (error) {
      setData([]);
      setRowCount(0);
      console.error("Error fetching Ahamove orders:", error);
    } finally {
      setIsLoading(false);
      sessionStorage.setItem(
        String(location.pathname),
        JSON.stringify({
          ...searchForm.getValues(),
          filterOwDate: filterOwDate,
          filterOrderStatus: filterOrderStatus,
        }),
      );
    }
  };

  const handleExport = async (rowCount: number) => {
    open();
    try {
      const {
        KeySearch,
        OrderNumber,
        Phone,
        FinishDate,
        StartDate,
        EndDate,
        InvOrgId,
        InvId,
        CodeSal,
        Attribute78,
        IsReturn,
      } = searchForm.values;

      // Cập nhật trạng thái applied sau khi search
      setAppliedIsReturn(IsReturn);

      let url = `/api/v1/CreateSellItem/get-list-return-sale?Skip=0&Take=${rowCount}&ShipingVendor=COD`;
      const params: string[] = [];
      if (KeySearch) params.push(`KeySearch=${encodeURIComponent(KeySearch)}`);
      if (OrderNumber)
        params.push(`OrderNumber=${encodeURIComponent(OrderNumber)}`);
      if (Phone) params.push(`Phone=${encodeURIComponent(Phone)}`);
      if (FinishDate)
        params.push(`FinishDate=${FinishDate.toISOString().slice(0, 10)}`);
      if (StartDate) params.push(`StartDate=${StartDate}`);
      if (EndDate) params.push(`EndDate=${EndDate}`);
      const resolvedInvId = InvId || InvOrgId;
      if (resolvedInvId && resolvedInvId.length > 0)
        params.push(`InvId=${resolvedInvId}`);
      if (InvOrgId && InvOrgId.length > 0) params.push(`InvOrgId=${InvOrgId}`);
      if (CodeSal && CodeSal.length > 0)
        params.push(`CodeSal=${encodeURIComponent(CodeSal)}`);
      if (Attribute78 && Attribute78.length > 0)
        params.push(`Attribute78=${Attribute78}`);
      if (IsReturn) params.push(`IsReturn=${IsReturn}`);
      // Sửa lỗi lệch ngày khi tìm kiếm ngày xuất kho
      if (filterOwDate) {
        const localDate = `${filterOwDate.getFullYear()}-${(
          filterOwDate.getMonth() + 1
        )
          .toString()
          .padStart(2, "0")}-${filterOwDate
          .getDate()
          .toString()
          .padStart(2, "0")}`;
        params.push(`OwDate=${localDate}`);
      }
      if (filterOrderStatus) params.push(`OrderStatus=${filterOrderStatus}`);
      if (params.length > 0) {
        url += "&" + params.join("&");
      }
      const response = await repositoryPos.get<MessageResponse<any>>(url);
      if (response && response.success) {
        const dataAPI = response.data?.pagedList?.lists || [];
        const dataExport = dataAPI.map((i: any) => ({
          "Mã đơn hàng": i.orderNumber || "",
          "Trạng thái đơn hàng":
            orderStatuses.find((item) => item.value === i.orderStatus)?.label ||
            i.orderStatus ||
            "",
          "Trạng thái chung": i.attribute12 || "",
          "Trạng thái đẩy đơn":
            i.attribute3 !== "DA_XUAT"
              ? "Chưa đẩy"
              : i.attribute1 &&
                  JSON.parse(i.attribute1) &&
                  JSON.parse(i.attribute1 || {})?.sharedLink
                ? "Đã đẩy"
                : "Không xác định",
          "Trạng thái kho":
            warehouseStatus.find((item) => item.value === i.attribute3)
              ?.label || "Chưa yêu cầu",
          "Ngày xuất kho": i.attribute37
            ? formatDateTransfer(i.attribute37)
            : "",
          "Kho hàng": `[${i.invOrgCode}] ${i.invOrgName}` || "",
          "Nhân viên bán hàng": i.sale || "",
          "Bộ phận giao hàng": i.shipingVendor || "",
          "Đơn vị vận chuyển":
            dataTransferShipping.find((item) => item.value === i.attribute76)
              ?.label ||
            i.attribute76 ||
            "",
          "Mã vận đơn COD": i.attribute77 || "",
          "Trạng thái đẩy đơn COD":
            i.attribute78 === "DA_DONG_GOI"
              ? "Đã đóng gói"
              : i.attribute78 === "CHUA_DONG_GOI"
                ? "Chưa đóng gói"
                : "",
          "Nhân viên đẩy đơn COD": i.attribute38 || "",
          "Ghi chú": i.attribute71 || "",
        }));
        const worksheet = XLSX.utils.json_to_sheet(dataExport);

        const objectMaxLength: any[] = [];
        dataExport.forEach((row: any) => {
          Object.keys(row).forEach((key, index) => {
            const headerLen = key ? key.toString().length : 0;
            const valueLen = row[key] ? row[key].toString().length : 0;
            const maxLen = Math.max(headerLen, valueLen);

            objectMaxLength[index] = Math.max(
              objectMaxLength[index] || 0,
              maxLen,
            );
          });
        });

        worksheet["!cols"] = objectMaxLength.map((w) => ({ wch: w + 5 }));

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Báo cáo COD");
        XLSX.writeFile(workbook, "Bao_cao_COD.xlsx");
      }
    } catch (error) {
      console.error("Error fetching Ahamove orders:", error);
    } finally {
      close();
    }
  };

  const handleCheckShipping = async (orderNumber: string) => {
    const res = await repositoryPos.get<MessageResponse<any>>(
      `/api/v1/CreateSellItem/check-shipping-push-t2?OrderNumber=${orderNumber}`,
    );

    if (res && res.success) {
      modalsTransferShippingFromCOD(orderNumber);
    } else {
      NotificationExtension.Fails(res?.message);
    }
  };

  const fetchDataBranch = async () => {
    const res = await getMasterOrgSelect();

    if (res) {
      const dataAPI = res
        ?.filter((item) => item.text && item.value)
        ?.map((item) => ({
          label: `${item.att1} - ${item.text}`,
          value: item.value?.toString(),
        }));

      setDataBranchSelect(dataAPI);
    }
  };

  const fetchDataEmployee = async () => {
    try {
      const res = await repositoryPos.get<MessageResponse<any>>(
        "/api/v1/TblDmEmployee/get-all",
      );
      if (res && res.success) {
        const dataAPI = (res.data || [])
          .filter((item: any) => item?.code)
          .map((item: any) => ({
            value: item.code?.toString(),
            label: `${item.fullname || ""} - ${item.code || ""}`,
          }));
        setDataEmployeeSelect(dataAPI);
      }
    } catch (error) {
      console.error("Error fetching employee data:", error);
      setDataEmployeeSelect([]);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.pageIndex, pagination.pageSize]);

  // Định nghĩa columns cho MantineReactTable
  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        header: "STT",
        accessorKey: "STT",
        Cell: ({ row }) => <>{row?.index + 1}</>,
        size: 50,
        enableColumnActions: false,
        enableSorting: false,
        enableResizing: false,
        enableColumnFilters: false,
      },
      {
        accessorKey: "orderNumber",
        header: "Mã đơn hàng",
        // // enableColumnActions: false,,
        enableColumnFilter: false,
        size: 160,
        Cell: ({ renderedCellValue, row }) => (
          <Tooltip label="Xem chi tiết">
            <Badge
              radius="sm"
              variant="dot"
              size="md"
              style={{ cursor: "pointer" }}
              color={renderedCellValue === null ? "red" : green.base}
              onDoubleClick={() => handleCheckView(row)}
            >
              {renderedCellValue === null ? "KHÔNG HỢP LỆ" : renderedCellValue}
            </Badge>
          </Tooltip>
        ),
      },
      {
        accessorKey: "orderStatus",
        header: "Trạng thái đơn hàng",
        // // enableColumnActions: false,,
        enableColumnFilter: false,
        size: 200,
        Cell: ({ row }) => {
          const orderStatus = row.original.orderStatus;
          let badgeColor;
          switch (orderStatus) {
            case "DON_HANG_TAM":
              badgeColor = "cyan";
              break;
            case "DON_HANG_CHOT":
              badgeColor = "violet";
              break;
            case "DON_HANG_DOI_TRA_TAM":
              badgeColor = "cyan";
              break;
            case "DON_HANG_HOAN_THANH":
              badgeColor = "green";
              break;
            case "DON_HANG_DOI_TRA":
              badgeColor = "green";
              break;
            case "THANH_TOAN_CHUA_HOAN_THANH":
              badgeColor = "red";
              break;
            case "pending":
              badgeColor = "yellow";
              break;
            case "DON_HANG_BAN_TAI_SHOP":
              badgeColor = "green";
              break;
            case "DON_HANG_CHO_DUYET_GIAM":
              badgeColor = olive_green.light;
              break;
            case "DON_HANG_DA_DUYET_GIAM":
              badgeColor = olive_green.medium;
              break;
            case "KHO_XUAT_HANG":
              badgeColor = sky_blue.medium;
              break;
            case "DON_HANG_DONG":
              badgeColor = "red";
              break;
            default:
              badgeColor = "gray";
          }
          return (
            <Badge
              size="md"
              color={badgeColor}
              fs={"12,5px"}
              fw={"bold"}
              radius="sm"
            >
              {row.original.orderStatus !== null
                ? getTextStatus(row)
                : "Không HỢP LỆ"}
            </Badge>
          );
        },
      },
      {
        accessorKey: "attribute12",
        header: "Trạng thái chung",
        Cell: ({ renderedCellValue }) => {
          return <>{renderedCellValue}</>;
        },
      },
      {
        // accessorKey: "attribute12",
        accessorKey: "pushStatus",
        header: "Trạng thái đẩy đơn",
        Cell: ({ row }) => {
          if (row?.original?.attribute3 === "DA_XUAT") {
            try {
              const attr1 = row?.original?.attribute1;
              if (attr1) {
                const data = JSON.parse(attr1);
                if (data.sharedLink) {
                  return (
                    <Flex align="center" gap={8}>
                      <Badge color="green" variant="light">
                        Đã đẩy
                      </Badge>
                    </Flex>
                  );
                } else {
                  // Không xác định: màu xám
                  return (
                    <Badge color="gray" variant="light">
                      Không xác định
                    </Badge>
                  );
                }
              }
            } catch (e) {
              // Không xác định: màu xám
              return (
                <Badge color="gray" variant="light">
                  Không xác định
                </Badge>
              );
            }
          }
          // Chưa đẩy: màu xám
          return (
            <Badge color="gray" variant="light">
              Chưa đẩy
            </Badge>
          );
        },
      },
      {
        accessorKey: "attribute3",
        header: "Trạng thái kho",
        Cell: ({ renderedCellValue, row }) => {
          const _status = warehouseStatus.find(
            (status) => status.value === row?.original?.attribute3?.toString(),
          );

          return (
            <Badge size="sm" color="cyan">
              {_status?.label ? _status.label : "Chưa yêu cầu"}
            </Badge>
          );
        },
      },
      {
        accessorKey: "attribute37",
        header: "Ngày xuất kho",
        Cell: ({ renderedCellValue }: any) => {
          if (
            typeof renderedCellValue === "string" ||
            renderedCellValue instanceof Date
          ) {
            return <>{formatDateTransfer(renderedCellValue)}</>;
          }
          return <>{formatDateTransfer(undefined)}</>;
        },
      },

      {
        accessorKey: "invOrgName",
        header: "Kho hàng",
        // enableColumnActions: false,,
        enableColumnFilter: false,
        Cell: ({ row, column }) => (
          <>{`[${row.original.invOrgCode}] ${row.original.invOrgName}`}</>
        ),
      },
      {
        accessorKey: "sale",
        header: "Nhân viên bán hàng",
        size: 180,
        enableColumnFilter: false,
      },
      {
        accessorKey: "shipingVendor",
        header: "Bộ phận giao hàng",
        // // enableColumnActions: false,,
        enableColumnFilter: false,
        Cell: ({ row, column }) => (
          <>{getShippingVendorText(row?.original?.shipingVendor ?? "")}</>
        ),
      },
      {
        accessorKey: "attribute76",
        header: "Đơn vị vận chuyển",
        Cell: ({ renderedCellValue }) => (
          <Badge color={getColorTransfer(renderedCellValue?.toString() ?? "")}>
            {getValueById(
              renderedCellValue?.toString() ?? "",
              dataTransferShipping,
              "label",
            ).length > 0
              ? getValueById(
                  renderedCellValue?.toString() ?? "",
                  dataTransferShipping,
                  "label",
                )
              : renderedCellValue}
          </Badge>
        ),
      },
      {
        accessorKey: "attribute77",
        header: "Mã vận đơn COD",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Badge
              radius="sm"
              variant="dot"
              size="md"
              style={{ cursor: "pointer" }}
              color={renderedCellValue === null ? "red" : "blue"}
            >
              {renderedCellValue === null
                ? "Không có mã vận đơn"
                : renderedCellValue}
            </Badge>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "attribute78",
        header: "Trạng thái đẩy đơn COD",
        Cell: ({ renderedCellValue }) => (
          <Badge color={renderedCellValue === "DA_DONG_GOI" ? "teal" : "gray"}>
            {renderedCellValue === "DA_DONG_GOI"
              ? "Đã đóng gói"
              : "Chưa đóng gói"}
          </Badge>
        ),
      },
      {
        accessorKey: "attribute38",
        header: "Nhân viên đẩy đơn COD",
      },
      {
        accessorKey: "attribute71",
        header: "Ghi chú",
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        size: 150,
        enableColumnActions: false,
        enableSorting: false,
        enableResizing: false,
        enableColumnFilters: false,
        enableColumnFilter: false,
        Cell: ({ row }) => {
          const actions = [];
          const attr1 = row.original.attribute1 || null;
          const sharedLink =
            row.original.attribute1 && isJSON(row.original.attribute1)
              ? JSON.parse(attr1)?.sharedLink
              : null;
          // if (
          //   row?.original?.shipingVendor === "COD" &&
          //   row?.original?.orderStatus === "DON_HANG_HOAN_THANH"
          // ) {
          //   actions.push(
          //     <Tooltip label="Đẩy lại Ahamove" key="push-ahamove">
          //       <ActionIcon
          //         onClick={() => handeOrderAhamove(row.original.orderNumber)}
          //         variant="light"
          //         aria-label="Settings"
          //         color="green"
          //       >
          //         <IconTruckDelivery size={20} stroke={1.5} />
          //       </ActionIcon>
          //     </Tooltip>
          //   );
          // }
          // Đẩy lại GHTK
          if (
            row?.original?.shipingVendor === "COD" &&
            row?.original?.orderStatus === "DON_HANG_HOAN_THANH" &&
            !row?.original?.attribute76 &&
            (row.original.attribute3 !== "DA_XUAT" || !sharedLink)
          ) {
            actions.push(
              <Tooltip label="Đẩy lại GHTK" key="push-ghtk">
                <ActionIcon
                  onClick={() => modalsConfirmInfo(row.original.orderNumber)}
                  variant="light"
                  aria-label="Settings"
                  color="green"
                >
                  <IconTruckDelivery size={20} stroke={1.5} />
                </ActionIcon>
              </Tooltip>,
            );
          }
          // Thông tin giao vận (icon link)
          try {
            const attr1 = row?.original?.attribute1;
            if (attr1) {
              const data = JSON.parse(attr1);
              if (data.sharedLink) {
                actions.push(
                  <Tooltip label="Thông tin giao vận" key="tracking-link">
                    <ActionIcon
                      color="blue"
                      variant="light"
                      onClick={() => {
                        window.open(
                          `https://i.ghtk.vn/${data.sharedLink}`,
                          "_blank",
                        );
                      }}
                      aria-label="Thông tin giao vận"
                    >
                      <IconFileExport size={20} stroke={1.5} />
                    </ActionIcon>
                  </Tooltip>,
                );
              }
            }
          } catch (e) {}
          // In nhãn GHTK: đơn đã đẩy sang GHTK (có mã vận đơn hoặc mã tra cứu)
          if (
            row.original.attribute76 === "GHTK" &&
            (row.original.attribute77 || sharedLink)
          ) {
            actions.push(
              <Tooltip label="In nhãn GHTK" key="print-ghtk-label">
                <ActionIcon
                  variant="light"
                  aria-label="In nhãn GHTK"
                  color="indigo"
                  onClick={() => printGhtkLabel(row.original.orderNumber)}
                >
                  <IconPrinter size={20} stroke={1.5} />
                </ActionIcon>
              </Tooltip>,
            );
          }
          if (!row.original.attribute77) {
            actions.push(
              <Tooltip label="Đơn vị vận chuyển khác" key="ghtk-more">
                <ActionIcon
                  variant="light"
                  aria-label="Settings"
                  color="orange"
                  onClick={() => handleCheckShipping(row.original.orderNumber)}
                >
                  <IconBinaryTree size={20} stroke={1.5} />
                </ActionIcon>
              </Tooltip>,
            );
          }
          return <Flex gap={10}>{actions}</Flex>;
        },
      },
    ],
    [dataTransferShipping, handleCheckView, modalsTransferShippingFromCOD],
  );

  // Lưu ghim cột - Function để lấy cấu hình từ localStorage
  const getColumnPinningStorage = () => {
    try {
      const columnPinningStorage = localStorage.getItem("codColumnPinning");
      return columnPinningStorage
        ? JSON.parse(columnPinningStorage)
        : { left: ["STT", "orderNumber"], right: ["action"] }; // Giá trị mặc định
    } catch (error) {
      console.error("Error parsing column pinning storage:", error);
      return { left: ["STT", "orderNumber"], right: ["action"] };
    }
  };

  // State cho columnPinning - khởi tạo từ localStorage
  const [columnPinning, setColumnPinning] = useState<ColumnPinningType>(() =>
    getColumnPinningStorage(),
  );

  // Effect để lưu columnPinning vào localStorage mỗi khi có thay đổi
  useEffect(() => {
    try {
      localStorage.setItem("codColumnPinning", JSON.stringify(columnPinning));
    } catch (error) {
      console.error("Error saving column pinning to localStorage:", error);
    }
  }, [columnPinning]);

  useEffect(() => {
    fetchDataBranch();
    fetchDataEmployee();
  }, []);

  // Chiều cao vùng cuộn của bảng, để chân bảng sát đáy màn hình
  const [tableHeight, setTableHeight] = useState<number>();

  const table = useMantineReactTable({
    columns,
    data: data || [],
    enableColumnResizing: true,
    enableTopToolbar: false,
    enableRowSelection: false,
    enableColumnFilters: false,
    enableSorting: false,
    enableColumnActions: false,
    enableStickyHeader: true,
    manualPagination: true,
    rowCount,
    onPaginationChange: setPagination,
    onColumnPinningChange: setColumnPinning,
    // Thiết lập initialState để đảm bảo columnPinning được áp dụng ngay từ đầu
    initialState: {
      columnPinning: {
        ...columnPinning,
      },
    },
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["20", "50", "100"],
    },
    state: {
      isLoading,
      pagination,
      showProgressBars: isLoading,
      columnPinning,
    },
    enableColumnPinning: true,
    mantineTableProps: {
      striped: true,
      highlightOnHover: true,
      withTableBorder: true,
      style: {
        backgroundColor: appliedIsReturn === "true" ? "#ffeaa7" : "inherit",
      },
    },
    mantineTableBodyRowProps: ({ row }: any) => ({
      style: {
        backgroundColor:
          appliedIsReturn === "true"
            ? "#fab1a0"
            : row.index % 2 === 0
              ? "#f8f9fa"
              : "white",
        borderLeft: appliedIsReturn === "true" ? "4px solid #e17055" : "none",
      },
    }),
    mantineTableContainerProps: {
      style: {
        maxHeight: tableHeight,
        minHeight: tableHeight,
        overflowX: "auto",
        overflowY: "auto",
      },
    },
  });
  useTableFillScreen(table, setTableHeight);

  return (
    <Box mt={10} style={{ overflowX: "hidden" }}>
      <Grid gutter={8}>
        <Grid.Col span={sizeGrid}>
          <TextInput
            leftSection={<IconSearch color="#15aabf" />}
            placeholder="Từ khoá"
            {...searchForm.getInputProps("KeySearch")}
            onKeyDown={(e) => {
              if (e.key === "Enter") fetchData();
            }}
          />
        </Grid.Col>
        <Grid.Col span={sizeGrid}>
          <DatePickerInput
            leftSection={<IconCalendarUp color="#15aabf" />}
            placeholder="Ngày bắt đầu"
            locale="vi"
            valueFormat="DD/MM/YYYY"
            value={
              searchForm.getValues()?.StartDate &&
              searchForm.getValues()?.StartDate.length > 0
                ? new Date(searchForm.getValues()?.StartDate ?? "")
                : null
            }
            onChange={(e) =>
              searchForm.setValues((prev) => ({
                ...prev,
                StartDate: e ? formatDateNotTimeZone(e ?? "") : "",
              }))
            }
          />
        </Grid.Col>
        <Grid.Col span={sizeGrid}>
          <DatePickerInput
            leftSection={<IconCalendarDown color="#15aabf" />}
            placeholder="Ngày kết thúc"
            locale="vi"
            valueFormat="DD/MM/YYYY"
            value={
              searchForm.getValues()?.EndDate &&
              searchForm.getValues()?.EndDate.length > 0
                ? new Date(searchForm.getValues()?.EndDate ?? "")
                : null
            }
            onChange={(e) =>
              searchForm.setValues((prev) => ({
                ...prev,
                EndDate: e ? formatDateNotTimeZone(e ?? "") : "",
              }))
            }
          />
        </Grid.Col>
        <Grid.Col span={sizeGrid}>
          <Select
            placeholder="Chi nhánh"
            leftSection={<IconBrandBootstrap color="#15aabf" />}
            data={dataBranchSelect}
            value={
              searchForm.getValues()?.InvId &&
              searchForm.getValues()?.InvId?.length > 0
                ? searchForm.getValues()?.InvId
                : searchForm.getValues()?.InvOrgId &&
                    searchForm.getValues()?.InvOrgId?.length > 0
                  ? searchForm.getValues()?.InvOrgId
                  : ""
            }
            searchable
            clearable
            nothingFoundMessage={"Không tìm thấy dữ liệu !"}
            onChange={(e) =>
              searchForm.setValues((prev) => ({
                ...prev,
                InvOrgId: e ? e : "",
                InvId: e ? e : "",
              }))
            }
          />
        </Grid.Col>
        <Grid.Col span={sizeGrid}>
          <Select
            leftSection={<IconSearch color="#15aabf" />}
            placeholder="Tìm người hưởng số"
            data={dataEmployeeSelect}
            value={
              searchForm.getValues()?.CodeSal &&
              searchForm.getValues()?.CodeSal?.length > 0
                ? searchForm.getValues()?.CodeSal
                : ""
            }
            searchable
            clearable
            nothingFoundMessage={"Không tìm thấy dữ liệu !"}
            onChange={(e) =>
              searchForm.setValues((prev) => ({
                ...prev,
                CodeSal: e ? e : "",
              }))
            }
          />
        </Grid.Col>
        <Grid.Col span={sizeGrid}>
          <TextInput
            leftSection={<IconFileSearch color="#15aabf" />}
            placeholder="Mã đơn hàng"
            {...searchForm.getInputProps("OrderNumber")}
            onKeyDown={(e) => {
              if (e.key === "Enter") fetchData();
            }}
          />
        </Grid.Col>
        <Grid.Col span={sizeGrid}>
          <TextInput
            leftSection={<IconNumbers color="#15aabf" />}
            placeholder="Số ĐT khách"
            {...searchForm.getInputProps("Phone")}
            onKeyDown={(e) => {
              if (e.key === "Enter") fetchData();
            }}
          />
        </Grid.Col>
        {/* <Grid.Col span={sizeGrid}>
            <DatePickerInput
              leftSection={<IconTimeDuration15 color="#15aabf" />}
              size="sm"
              placeholder="Thời gian hoàn thành đơn"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              clearable
              {...searchForm.getInputProps("FinishDate")}
            />
          </Grid.Col> */}
        <Grid.Col span={sizeGrid}>
          <DatePickerInput
            leftSection={<IconTimeDuration15 color="#15aabf" />}
            size="sm"
            placeholder="Ngày xuất kho"
            locale="vi"
            valueFormat="DD/MM/YYYY"
            clearable
            value={
              filterOwDate && String(filterOwDate).length > 0
                ? new Date(filterOwDate)
                : null
            }
            onChange={setFilterOwDate}
          />
        </Grid.Col>
        <Grid.Col span={sizeGrid}>
          <Select
            placeholder="Trạng thái đơn hàng"
            data={orderStatusOptions}
            value={filterOrderStatus}
            onChange={(value) => setFilterOrderStatus(value || "")}
            clearable
            searchable
          />
        </Grid.Col>
        <Grid.Col span={sizeGrid}>
          <Select
            placeholder="Trạng thái đẩy đơn COD"
            data={orderStatusCOD}
            value={
              searchForm.getValues()?.Attribute78 &&
              searchForm.getValues()?.Attribute78?.length > 0
                ? searchForm.getValues()?.Attribute78
                : ""
            }
            onChange={(e) =>
              searchForm.setValues((prev) => ({
                ...prev,
                Attribute78: e ? e : "",
              }))
            }
            clearable
          />
        </Grid.Col>
        <Grid.Col span={sizeGrid}>
          <Select
            placeholder="Trạng thái nhập lại"
            data={isReturnOptions}
            value={isReturnFilter}
            onChange={(e) => {
              const newValue = e ? e : "false";
              setIsReturnFilter(newValue);
              searchForm.setValues((prev) => ({
                ...prev,
                IsReturn: newValue,
              }));
            }}
            clearable
          />
        </Grid.Col>
        <Grid.Col span={sizeGrid}>
          <Button
            leftSection={<IconSearch size={14} />}
            color="blue"
            variant="outline"
            onClick={() => fetchData()}
          >
            Tìm kiếm
          </Button>
        </Grid.Col>
      </Grid>
      {/* Nút nằm trên hàng breadcrumb của ListTabCOD */}
      {toolbar &&
        createPortal(
          <Flex gap={"xs"}>
            <Button
              leftSection={<IconRefresh size={16} />}
              onClick={() => fetchData()}
              loading={isLoading}
            >
              Làm mới
            </Button>
            <Button
              leftSection={<IconFileExport size={16} />}
              // onClick={() => handleExport()}
              onClick={() => fetchData(true)}
            >
              Export Excel
            </Button>
          </Flex>,
          toolbar,
        )}
      <Box mt={20}>
        <MantineReactTable table={table} />
      </Box>
    </Box>
  );
};

export default COD;
